import type { ReactNode } from "react";

import { useLocale } from "@/i18n/locale";
import type { Localized } from "@/i18n/types";
import { cn } from "@/lib/cn";

type SectionProps = {
  id: string;
  label: Localized;
  title?: Localized;
  children: ReactNode;
  className?: string;
};

export function Section({ id, label, title, children, className }: SectionProps) {
  const { t } = useLocale();

  return (
    <section id={id} className={cn("border-t border-border py-16 sm:py-24", className)}>
      <div className="mx-auto w-full max-w-5xl px-6">
        <header className="mb-10 flex items-baseline gap-4">
          <h2 className="label text-accent">{t(label)}</h2>
          {title ? <p className="text-sm text-muted">{t(title)}</p> : null}
        </header>
        {children}
      </div>
    </section>
  );
}
